import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { api, fmtDate, imgUrl } from "@/api";
import { useLang } from "@/i18n";

export default function ArtikelDetailPage() {
  const { id } = useParams();
  const { t, lang } = useLang();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/articles/${id}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="artikel-not-found">
        <p className="text-slate-500">404</p>
        <Link to="/artikel" className="text-emerald-800 font-semibold hover:underline">{t("common.back")}</Link>
      </div>
    );
  }
  if (!article) return <div className="max-w-3xl mx-auto px-6 py-24 text-slate-500">{t("common.loading")}</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14" data-testid="artikel-detail-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Link to="/artikel" className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-800 hover:text-[#D4AF37] transition-colors mb-8" data-testid="artikel-back-link">
          <ArrowLeft className="h-4 w-4" /> {t("common.back")}
        </Link>
        <span className="block text-[11px] font-bold uppercase tracking-widest text-[#D4AF37] mb-3">{article.category.replace("-", " ")}</span>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-emerald-950 tracking-tight leading-tight">{article.title}</h1>
        <p className="text-sm text-slate-500 mt-4">{fmtDate(article.created_at, lang)} · {t("artikel.published_by")} {article.author_name}</p>
        {article.cover && <img src={imgUrl(article.cover)} alt={article.title} className="w-full aspect-video object-cover rounded-xl mt-8 border border-emerald-900/10" />}
        <div className="prose-content text-slate-700 text-base leading-relaxed mt-10">
          {article.content.split("\n\n").filter(Boolean).map((par, i) => (
            <p key={i}>{par}</p>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
